<template>
    <pm-custom-dialog v-if="visible" v-model="visible">


        <div style="background: url(/images/onboarding/onboarding-consultation.jpg) center center / contain no-repeat rgb(255, 255, 255); margin: 0px 0px 20px 0; width: 100%; height: 170px;"></div>

        <div style="margin-bottom: 16px; text-align: center;">
            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">Let us know you better!</h2>
        </div>

        <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px; padding: 0 30px;">
            In order to provide you the best possible services please choose:
        </p>
        <br/>
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">

            <div v-for="option in options" :key="option.value"
                :style="selected === option.value ? 'border: 2px solid blue;' : (selected ? 'opacity: .5;' : '')"
                @click="handleClick(option.value)"
                style="border: 2px solid #fff; text-transform: uppercase; margin: 0 0 16px 0; width: 230px; line-height: 38px; border-radius: 8px; box-shadow: 0 0 8px rgba(0,0,0,.15);">
                {{ option.text }}
            </div>
            <br/>
            <span @click="close" style="text-decoration: underline;" v-if="selected">close</span>
        </div>

    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
        selected: localStorage.getItem('userProfession'),
        options: [
            {
                text: "I'm a Dentist",
                value: "Dentist"
            },
            {
                text: "I'm a Dental Student",
                value: "Student"
            },
            {
                text: "Other",
                value: "Other"
            }
        ]
    }),
    created() {
        this.$bus.$on('user-profession-dialog:show', () => {
            this.show();
        });
    },
    methods: {
        show() {
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        handleClick(data) {
            if (this.selected !== null) return;

            localStorage.setItem('userProfession', data);
            window.Tracker.logEvent({
                event_name: "user_profession",
                event_category: "user",
                event_label: data,
            });

            this.selected = data;
            // this.visible = false;
        },

    }
}
</script>
